import { Suspense, ReactNode } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { VideoPreloader } from 'src/components/VideoPreloader';

interface QueryBoundariesProps {
  children: ReactNode;
}

export const QueryBoundaries = ({ children }: QueryBoundariesProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary onReset={reset} FallbackComponent={ErrorView}>
        <Suspense fallback={<VideoPreloader />}>{children}</Suspense>
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);

const ErrorView = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation();
  return (
    <div className="error-page">
      <div>{error.message}</div>
      <button title="Retry" onClick={resetErrorBoundary}>
        {t('general.retry')}
      </button>
    </div>
  );
};
